import React from 'react'
import clsx from 'clsx'
import { FormControl, FormHelperText } from '@material-ui/core'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import useStyles from './FormFieldsStyle'
import { EventsIcon } from '../../../images/events'
import dayjs from 'dayjs'

export default function DatePicker({ field, values, setValues, errors }) {
  const classes = useStyles()
  return (
    <FormControl
      className={field.withMargin && classes.withMargin}
      variant="outlined"
      fullWidth={field.fullWidth}
    >
      <div className={classes.inputLabel} shrink>
        {field.label}
      </div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MUIDatePicker
          className={clsx(
            classes.customTimePicker,
            classes.customBorder,
            classes.inputFont
          )}
          onChange={(value) => {
            setValues({ ...values, [field.key]: value })
          }}
          value={
            typeof values[field?.key] === 'string'
              ? dayjs(values[field?.key])?.endOf('day') 
              : values[field?.key]?.endOf('day') || dayjs()?.endOf('day') 
          }
          format="DD/MM/YYYY"
          slots={{
            openPickerIcon: EventsIcon,
          }}
        />
      </LocalizationProvider>
      {errors[field.key] && (
        <FormHelperText className={classes.errorLabel}>
          {errors[field.key]}
        </FormHelperText>
      )}
    </FormControl>
  )
}
